export default "__VITE_ASSET__CWqX$_c5__"